import ApiService from './ApiService'

export const getApiData = (data) => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map((sort) => {
            if (!sort.order) return sort
            datas.ordering =
                sort.order === 'desc' ? `-${sort.key}` : `${sort.key}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.is_active = data.selectedTab === 'active' ? true : false
        }
    }
    return ApiService.get('/company/company-admins/', datas)
}
export const createApiRecord = (data) =>
    ApiService.post('/company/company-admins/', data)
export const getApiRecord = (id) =>
    ApiService.get(`/company/company-admins/?company_admin_id=${id}`)
export const updateApiRecord = (id, data) =>
    ApiService.patch(`/company/company-admins/${id}/`, data)
export const updateApiStatus = (id, data) =>
    ApiService.patch(`/company/company-admins/${id}/`, data)
export const deleteApiRecord = (id) =>
    ApiService.delete('/company/company-admins', id)
export const activateApiRecord = (data) =>
    ApiService.post('/company/activate-user/', data)
